<template>
    <el-dialog title="从语义库同步" width="50%" :close-on-click-modal="false" append-to-body :visible.sync="visible">
        <el-form size="small" :model="form" ref="form" v-loading="loading" @keyup.enter.native="doSubmit()"
                 @submit.native.prevent>
            <el-input
                    size="mini"
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
            </el-input>
            <el-tree
                    :data="treeData"
                    show-checkbox ref="tree"
                    node-key="id" :check-strictly="true"
                    :default-expand-all="true"
                    @check-change="handleCheckNode"
                    :filter-node-method="filterNode"
                    :props="defaultProps">
                <template slot-scope="{ node, data }">
                    <div>{{ data.semanticName }}（{{ data.semanticCorpusDataNum }}）</div>
                </template>
            </el-tree>
            <el-descriptions class="m_t1" title="已选数据" v-if="selectNodes.length"></el-descriptions>
            <el-tag class="m_r1"
                    v-for="item in selectNodes"
                    :key="item.id"
                    closable
                    @close="deleteTag(item)">
                {{ item.dataName }}
            </el-tag>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                loading: false,
                filterText: '',
                treeData: [],
                defaultProps: {
                    children: 'children',
                    label: 'semanticName'
                },
                selectNodes: [],
                form: {},
                basicRangeList: []
            }
        },
        watch: {
            filterText(val) {
                this.$refs.tree.filter(val);
            }
        },
        methods: {
            // basicRangeList 已添加的值域数组
            init(basicRangeList) {
                this.basicRangeList = basicRangeList
                this.filterText = ''
                this.treeData = []
                this.selectNodes = []
                this.visible = true
                this.$nextTick(() => {
                    this.getList()
                })
            },
            // 获取树形数据
            getList() {
                this.loading = true
                this.$axios(this.api.academic.semanticcorpusQueryListAll).then(res => {
                    if (res.status) {
                        this.treeData = res.data
                    }
                    this.loading = false
                })
            },
            filterNode (value, data, node) {
                if (!value) return true
                let parentNode = node.parent, semanticNames = [node.label], level = 1
                while (level < node.level) {
                    semanticNames = [...semanticNames, parentNode.label]
                    parentNode = parentNode.parent
                    level++
                }
                return semanticNames.some(label => label.indexOf(value) !== -1)
            },
            handleCheckNode() {
                let nodes = this.$refs.tree.getCheckedNodes()
                this.selectNodes = this.selectNodes.filter(item1 => {
                    item1.parintId = item1.parintId.filter(item1 => {
                        return nodes.findIndex(item2 => item2.id === item1) !== -1;
                    });
                    return item1.parintId.length != 0
                })
                let allSelectNode = []
                nodes.forEach(item => {
                    item.semanticCorpusData.forEach(item2 => {
                        this.$set(item2, 'parintId', item.id)
                    })
                    allSelectNode.push(...item.semanticCorpusData)
                })
                if (this.selectNodes.length == 0) {
                    this.selectNodes = allSelectNode.map(item => {
                        let data = JSON.parse(JSON.stringify(item))
                        data.parintId = [data.parintId]
                        return data
                    })
                } else {
                    let allParintIds = []
                    let noRepeatData = []
                    this.selectNodes.forEach(item => {
                        allParintIds.push(...item.parintId)
                    })
                    allParintIds = [...new Set(allParintIds)];
                    allSelectNode.forEach(item => {
                        let reapet = allParintIds.filter(item2 => item.parintId == item2)
                        if (reapet.length == 0) {
                            noRepeatData.push(item)
                        }
                    })
                    noRepeatData.forEach(item => {
                        let reapet = this.selectNodes.filter(item2 => item2.dataName == item.dataName)
                        if (reapet.length == 0) {
                            let data = JSON.parse(JSON.stringify(item))
                            data.parintId = [data.parintId]
                            this.selectNodes.push(data)
                        } else {
                            this.selectNodes.forEach(item3 => {
                                if (item3.dataName == reapet[0].dataName) {
                                    item3.parintId.push(item.parintId)
                                }
                            })
                        }
                    })
                }
            },
            deleteTag(row) {
                this.$confirm(`您是否确认删除数据?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.selectNodes = this.selectNodes.filter(item => item.id != row.id)
                    let allParintIds = []
                    this.selectNodes.forEach(item => {
                        allParintIds.push(...item.parintId)
                    })
                    allParintIds = [...new Set(allParintIds)];
                    this.$nextTick(() => {
                        this.$refs.tree.setCheckedKeys(allParintIds)
                    })
                })
            },
            // 确定
            doSubmit() {
                if (!this.selectNodes.length) {
                    this.$message.warning('请选择数据')
                    return
                }
                let list = JSON.parse(JSON.stringify(this.basicRangeList))
                this.selectNodes.map(item => {
                    list.push({
                        basicRange: item.dataName,
                        sort: list.length + 1
                    })
                })
                let val = list.reduce((acc, current) => {
                    const value = current['basicRange'];
                    const isDuplicate = acc.some(item => item['basicRange'] === value);
                    if (!isDuplicate) {
                        acc.push(current);
                    }
                    return acc;
                }, []);
                this.$emit('getRangeLibrary', val)
                this.visible = false
            }
        }
    }
</script>

<style scoped>
</style>
